// src/features/staff/pages/ProfilePage/components/ProfileHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
} from '@mui/material';
import {
  Lock as LockIcon,
  Dialpad as DialpadIcon,
} from '@mui/icons-material';
import PageHeader from '../../../../../components/common/PageHeader';
import PersonIcon from '@mui/icons-material/Person';

export default function ProfileHeader({ onChangePassword, onManagePin, onDisablePin, pinEnabled = false }) {
  const { t } = useTranslation(['staff']);

  return (
    <PageHeader
      icon={PersonIcon}
      title={t('staff:profile.title')}
      subtitle={t('staff:profile.subtitle')}
      actions={<>
        {pinEnabled && (
          <Button
            variant="text"
            color="error"
            onClick={onDisablePin}
          >
            {t('staff:profile.disable_pin')}
          </Button>
        )}
        <Button
          variant="outlined"
          startIcon={<DialpadIcon />}
          onClick={onManagePin}
        >
          {t('staff:profile.manage_pin')}
        </Button>
        <Button
          variant="contained"
          startIcon={<LockIcon />}
          onClick={onChangePassword}
        >
          {t('staff:profile.change_password')}
        </Button>
      </>}
    />
  );
}